import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { AbstractContentPane } from '@app/library/panes/models/abstract-content-pane';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { FeedPostFormComponent } from '../../../feed/feed-post-form/feed-post-form.component';

@Component({
  selector: 'app-people-news',
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    LibraryElementsModule,
    SpinnersModule,
    NoContentStubComponent,
    ContentCardModule,
    FeedPostFormComponent,
  ],
  templateUrl: './people-news.component.html',
  styleUrls: ['./people-news.component.scss'],
})
export class PeopleNewsComponent extends AbstractContentPane {
  navigate(url: string): void {
    void this.router.navigateByUrl(`my-classes/${url}`).catch();
  }

  protected onContentLoaded() {
    this.isVisible = true;
  }

  public onPosted() {
    this._pane = {
      ...this._pane,
      loaded: false,
      content: [],
    };
    this.loadPane();
  }

  public trackByFn(index) {
    return index;
  }
}
